import {
    STORED_ERRORS
} from "./actionTypes";

export const storeErrorMessages = (message, typeOfError) => async (dispatch) => {
    const error = {displayMessage: {message}, type: {typeOfError}}
    dispatch({ type: STORED_ERRORS, payload: error });
};